import React from 'react';

import { ICohort } from '../../utils/interfaces/DbInterfaces';

import styles from './LeagueInfo.module.scss';

interface ILeagueInfoProps {
  cohort?: ICohort;
  userRank?: number;
}

// Helper function to get league name and icon
export const getLeagueInfo = (tier: string) => {
  switch (tier) {
    case 'wd':
      return { name: 'Wood League', icon: '/images/wood.svg' };
    case 'br':
      return { name: 'Bronze League', icon: '/images/bronze.svg' };
    case 'si':
      return { name: 'Silver League', icon: '/images/silver.svg' };
    case 'go':
      return { name: 'Gold League', icon: '/images/gold.svg' };
    case 'pl':
      return { name: 'Platinum League', icon: '/images/platinum.svg' };
    case 'di':
      return { name: 'Diamond League', icon: '/images/diamond.svg' };
    case 'll':
      return { name: 'Logic Legend League', icon: '/images/logic_legend.svg' };
    case 'ss':
      return { name: 'Script Samurai League', icon: '/images/script_samurai.svg' };
    case 'bs':
      return { name: 'Bug Slayer League', icon: '/images/bug_slayer.svg' };
    case 'sc':
      return { name: 'Supreme Coder League', icon: '/images/supreme_coder.svg' };
    case 'mc':
      return { name: 'Master Coder League', icon: '/images/master_coder.svg' };
    default:
      return { name: 'Wood League', icon: '/images/wood.svg' };
  }
};

const LeagueInfo = ({ cohort, userRank }: ILeagueInfoProps) => {
  const handleClick = () => {
    const cohortElement = document.getElementById('cohort');

    if (cohortElement) {
      cohortElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  if (!cohort || !cohort.users.length) {
    return (
      <div
        className={styles.leagueInfo}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role='button'
        tabIndex={0}
        aria-label='View league leaderboard'
      >
        <div className={styles.icon}>
          <img src='/images/bronze.svg' alt='Bronze League' className={styles.leagueIcon} />
        </div>
        <div className={styles.details}>
          <div className={styles.title}>Bronze League</div>
          <div className={styles.rank}>#1 of 1</div>
        </div>
        <div className={styles.arrow}>›</div>
      </div>
    );
  }

  const userTier = cohort.users[0]?.tier || 'br';
  const leagueInfo = getLeagueInfo(userTier);

  return (
    <div
      className={styles.leagueInfo}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role='button'
      tabIndex={0}
      aria-label='View league leaderboard'
    >
      <div className={styles.icon}>
        <img src={leagueInfo.icon} alt={leagueInfo.name} className={styles.leagueIcon} />
      </div>
      <div className={styles.details}>
        <div className={styles.title}>{leagueInfo.name}</div>
        <div className={styles.rank}>
          #{typeof userRank === 'number' ? userRank : cohort.userRank} of {cohort.totalUsers}
        </div>
      </div>
      <div className={styles.arrow}>›</div>
    </div>
  );
};

LeagueInfo.defaultProps = {
  cohort: undefined,
  userRank: undefined,
};

export default LeagueInfo;
